export default __webpack_public_path__ + "static/media/prof1.6d956a7a.jpg";